export default "__VITE_ASSET__CYxJUn1M__"